import React from 'react';

import type { Trip } from '../../../model/Trip';
import { hoursBetween } from '../../../services/DateTime';
import { Sprite, SpriteName } from '../../Sprite';
import T from '../../Translate';

interface Props {
  trip: Trip;
}

export default function TripModalBody({ trip }: Props) {
  const timeTillAcceptanceTime = Math.max(hoursBetween(trip.confirm_to, new Date(), false), 0);

  return (
    <>
      <h2 className="mb-4 text-center" id="reservationLabel">
        <T id="modals.trip.reservationSend" />
      </h2>
      <ul className="list__status mb-0">
        <li className="list__status--item mb-3">
          <figure>
            <Sprite name={SpriteName.INFO} />
          </figure>
          <span className="text-muted font-size-lg text-left">
            <T data={{ count: timeTillAcceptanceTime }} id="modals.trip.ownerAcceptanceTime" />
          </span>
        </li>
        <li className="list__status--item">
          <figure>
            <Sprite name={SpriteName.INFO} />
          </figure>
          <span className="text-muted font-size-lg text-left">
            <T id="modals.trip.recommendation" />
          </span>
        </li>
        <li className="list__status--item">
          <figure>
            <Sprite name={SpriteName.INFO} />
          </figure>
          <span className="text-muted font-size-lg text-left">
            <T id="modals.trip.paymentInfo" />
          </span>
        </li>
      </ul>
    </>
  );
}
